import {GeneralAction} from "../../../@types/actions";
import {SET_CLASSIC_BOOKMAKER} from "../../../constants/OddsConstants";

export const SetBookmakerAction = (data: number): GeneralAction<number> => ({
    type: SET_CLASSIC_BOOKMAKER,
    payload: data
});
